export default {
  "___manage-crossover_page-title": "",
  "manage-crossover_page-subtitle": "Update your selections",
  "manage-crossover_title_automatically-submit-these-claims": "Choose to automatically submit these claims:",
  "___manage-crossover_title_medical": "",
  "___manage-crossover_text_medical-description": "",
  "___manage-crossover_title_ptp": "",
  "___manage-crossover_text_ptp-description": "",
  "___manage-crossover_title_dental": "",
  "___manage-crossover_text_dental-description": "",
  "manage-crossover_form-label_medical": "Medical Selection",
  "manage-crossover_form-label_ptp": "Pay the Provider Selection",
  "manage-crossover_form-label_dental": "Dental Selection",
  "manage-crossover_action_submit": "Save Selections",
  "___manage-crossover_title_confirm-close": "",
  "___manage-crossover_text_confirm-close": "",
  "___manage-crossover_action_confirm-close_cancel": "",
  "___manage-crossover_action_confirm-close_confirm": "",
  "manage-crossover_text_loading-message": "Updating Your Crossover Selections…",
  "manage-crossover_text_success-message": "Your updates have been saved successfully. A notification email has been sent to your account.",
  "manage-crossover_text_error-message_default": "Vestibulum id ligula porta felis euismod semper.",
  "___manage-crossover_action_done": "",
  "___manage-crossover_label_yes": "",
  "___manage-crossover_label_no": "",
  "manage-crossover_form-label_terms-and-conditions": "I agree the health care expenses submitted through Automatic Claim Submissions will not be eligible for benefit payments by any other insurance carrier and that such expenses will not be manually submitted by me to this or any other reimbursement account.",
  "___manage-crossover_form-error_terms-and-conditions_required": "",
  "manage-crossover_text_refresh-data-error-message": "Your crossover selections have been updated but we were unable to refresh the data on the screen. Please refresh the page.",
};